<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="40%"
  >
    <div>
      <template v-if="customMain">
        <slot name="main" />
        <template v-if="hasDate">
          <date-picker
            :query.sync="dateValue"
            v-bind="$attrs"
            v-on="$listeners"
            :limit="limit"
            :limitMonth="limitMonth"
            @change="dateChange"
          />
        </template>
      </template>
      <template v-else>
        <div class="text">选择导出报表的时间范围</div>
        <date-picker
          :query.sync="dateValue"
          v-bind="$attrs"
          v-on="$listeners"
          :limit="limit"
          :limitMonth="limitMonth"
          @change="dateChange"
        />
      </template>
    </div>
    <template #footer>
      <div class="tips">提示：导出的报表为.xlsx格式文件，请用Excel软件打开</div>
      <div>
        <el-button type="default" :size="formSize" @click="handleClose">
          取消
        </el-button>
        <el-button type="primary" :size="formSize" @click="handleSubmit">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'ExportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    limit: {
      type: String,
      default: 'limitMonth',
    },
    /**
     * 限制月数范围
     */
    limitMonth: {
      type: Number,
      default: 1,
    },
    // 自定义导出内容
    customMain: {
      type: Boolean,
      default: false,
    },
    // 自定义校验
    checkFun: {
      type: Function,
    },
    // 自定义内容是否需要默认时间
    hasDate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectDate: '',
      dateValue: {
        beginTime: '',
        endTime: '',
      },
    };
  },
  watch: {
    visible: {
      handler(newV) {
        if (!newV) {
          this.dateValue = {
            beginTime: '',
            endTime: '',
          };
        }
      },
    },
  },
  methods: {
    handleSubmit() {
      let flag = true;
      // 自定义校验内容
      if (this.checkFun && typeof checkFun === 'function') {
        flag = this.checkFun();
      } else {
        const { beginTime, endTime } = this.dateValue;
        if ((!beginTime || !endTime) && this.hasDate) {
          this.$message.warning('请选择导出报表的时间范围！');
          return;
        }
        flag = true;
      }
      if (flag) {
        this.$emit('export-report', this.dateValue, this.customMain);
      }
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    dateChange(type) {
      if (type === 1 && !this.dateValue.beginTime) {
        this.dateValue.endTime = '';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.text {
  margin-bottom: 20px;
}
::v-deep {
  .el-dialog {
    min-width: 550px;
  }
  .el-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tips {
      font-size: 12px;
      color: #ff3741;
    }
  }
  .el-dialog__body {
    padding: 20px;
  }
  .data-show {
    align-items: center;
  }
}
</style>
